import { httpClient } from '@/core/api/client/httpClient'
import type { Resource, ResourceFileUrl } from '../types'

interface BffResourceListResponse {
  success: boolean
  data: Resource[]
}

interface BffFileResponse {
  success: boolean
  data: ResourceFileUrl
}

interface BffMediaResponse {
  success: boolean
  data: { name: string; url: string; contentType: string; version: string } | null
}

export const resourceService = {
  async getByCategory(category: string, type?: string): Promise<Resource[]> {
    const params = new URLSearchParams({ category })
    if (type) params.set('type', type)

    const data = await httpClient.get<BffResourceListResponse>(
      `/api/v1/resources?${params.toString()}`,
    )
    return data.data ?? []
  },

  async getFileUrl(id: string): Promise<ResourceFileUrl> {
    // IDs con extensión son nombres de archivo en Blob — se obtiene SAS URL desde /api/media/
    if (id.includes('.')) {
      const res = await httpClient.get<BffMediaResponse>(
        `/api/media/${encodeURIComponent(id)}?canal=web`,
      )
      const data = res.data
      if (!data?.url) throw new Error(`No se encontró la URL para ${id}`)
      // La SAS URL expira en ~1h; restamos 5 min de margen para el cache
      const expiresAt = new Date(Date.now() + 55 * 60 * 1000).toISOString()
      return { url: data.url, expiresAt }
    }
    const data = await httpClient.get<BffFileResponse>(`/api/v1/files/${id}`)
    return data.data
  },
}
